import $ from 'jquery'

export default class Tabs {
  static init () {
    $('.tab:first').addClass('active')

    $(document).on('click', '.tab', (event) => {
      event.preventDefault()
      const _href = $(event.target).attr('href')

      $('.tab').removeClass('active')
      $(event.target).addClass('active')
      $('.tab-content').hide()
      $(_href).fadeIn()
    })
  }
}
